import clsx from 'clsx'
import { motion } from 'framer-motion'

import { repeat } from '../../lib/repeat'
import { trackingService, Interactions } from '../../machines/tracking.machine'
import { useNaturalPowerContext } from '../NaturalPowerCalculatorProvider'
import { DragConstraint } from './Constraint'
import { useStepSlider } from './Context'
import { Dash } from './Dash'
import { getNearestStep } from './utils'

interface TrackProps {
  className?: string
  children?: preact.ComponentChildren
}

export function Track({ className, children }: TrackProps) {
  const services = useNaturalPowerContext()
  const [naturalPowerRatio, setNaturalPowerRatio] = services.naturalPower

  const { steps, trackLength } = useStepSlider()
  const step = naturalPowerRatio * steps

  const handleTap = ({ offsetX }: MouseEvent | PointerEvent) => {
    const ratio = getNearestStep(offsetX, trackLength, steps) / steps
    setNaturalPowerRatio(ratio)
    services.costInput.send({ type: 'Update inputs', naturalPowerRatio: ratio })
    trackingService.send({ type: 'Interact', name: Interactions.contributionSlider })
  }

  return (
    <DragConstraint>
      <div className={clsx('absolute flex flex-col items-start justify-start w-full', className)}>
        <motion.div
          className="grid w-full py-3 cursor-pointer gap-x-3 md:gap-x-4"
          style={{ gridTemplateColumns: `repeat(${steps}, minmax(0, 1fr))` }}
          onTap={handleTap}>
          {repeat(steps, (i) => (
            <Dash active={step > i} />
          ))}
        </motion.div>
        {children}
      </div>
    </DragConstraint>
  )
}
